import React from 'react';
import HelmetBuilder from '../components/helmet-builder';
import BlogPostHero from '../components/blog-post-hero';
import BlogPostPreview from '../components/blog-post-preview';
import BlogPostGridItem from '../components/blog-post-grid-item';
import { filterBlogPosts } from '../utils/posts';

import './blog.scss';

const Blog = ({ data, location }) => {
  // Grab the newest "featured" post, or the most recent post if none.
  // Filter remaining collection to exlude the featured post.
  const posts = filterBlogPosts(data.allContentfulBlogPost.edges)
  const featuredPost = data.featured
    ? data.featured.edges[0].node
    : data.allContentfulBlogPost.edges[0].node;
  const filteredPosts = posts.filter(({ node }) => {
    return node.slug !== featuredPost.slug;
  });

  return (
    <div className="blog">
      <HelmetBuilder
        data={data.blogLanding.edges[0].node}
        pathname={location.pathname}
      />
      <BlogPostHero
        title={featuredPost.title}
        imageUrl={featuredPost.heroImage ? featuredPost.heroImage.file.url : null}
        author={featuredPost.postAuthor ? featuredPost.postAuthor.name : null}
        date={featuredPost.postDate}
        excerpt={featuredPost.introductoryQuote ? featuredPost.introductoryQuote.introductoryQuote : null}
        featured={true}
        slug={featuredPost.slug}
      />
      {filteredPosts.map(({ node }, i) => {
        if(i == 0) {
          return (
            <BlogPostPreview
              key={node.id}
              imageUrl={node.heroImage && node.heroImage.file ? node.heroImage.file.url : null}
              title={node.title}
              author={node.postAuthor ? node.postAuthor.name : null}
              date={node.postDate}
              excerpt={node.introductoryQuote ? node.introductoryQuote.introductoryQuote : null}
              category={node.category ? node.category.title : null}
              slug={node.slug}
              variant={i % 2 === 0 ? 'alt' : ''}
            />
          );
        };
      })}
      <div className="blog-post-grid">
        <div className="blog-post-grid__wrapper">
          {filteredPosts.map(({ node }, i) => {
            if(i != 0) {
              return (
                <BlogPostGridItem
                  key={node.id}
                  imageUrl={node.heroImage && node.heroImage.file ? node.heroImage.file.url : null}
                  title={node.title}
                  author={node.postAuthor ? node.postAuthor.name : null}
                  date={node.postDate}
                  excerpt={node.introductoryQuote ? node.introductoryQuote.introductoryQuote : null}
                  category={node.category ? node.category.title : null}
                  slug={node.slug}
                  variant={i % 2 === 0 ? 'alt' : ''}
                />
              );
            };
          })}
        </div>
      </div>
    </div>
  );
};

export const pageQuery = graphql`
  query BlogPosts {
    allContentfulBlogPost(sort: { fields: [postDate], order: DESC }) {
      edges {
        node {
          metadata {
            title
            description
            ogimage {
              file {
                url
              }
            }
            keywords
          }
          id
          title
          slug
          postDate
          postAuthor {
            name
          }
          category {
            title
          }
          heroImage {
            file {
              url
            }
          }
          introductoryQuote {
            introductoryQuote
          }
        }
      }
    }
    featured: allContentfulBlogPost(
      filter: { featured: { eq: true } }
      sort: { fields: [postDate], order: DESC }
      limit: 1
    ) {
      edges {
        node {
          id
          title
          slug
          postDate
          postAuthor {
            name
          }
          category {
            title
          }
          heroImage {
            file {
              url
            }
          }
          introductoryQuote {
            introductoryQuote
          }
        }
      }
    }
    blogLanding: allContentfulBlogLandingPage {
      edges {
        node {
          metadata {
            title
            description
            ogimage {
              file {
                url
              }
            }
            keywords
          }
        }
      }
    }
  }
`;

export default Blog;



// WEBPACK FOOTER //
// ./src/pages/blog.js